import clearSearchBox from '../actions/clearSearchBox';
import getSuggestions from '../actions/getSuggestions';
import onGuidedFormulationSuggestionSelected from '../actions/onGuidedFormulationSuggestionSelected';
import onGuidedFormulationSuggestionSelectedInternal from '../actions/onGuidedFormulationSuggestionSelectedInternal';
import onRemoveGuidedFormulationPill from '../actions/onRemoveGuidedFormulationPill';
import onRemoveGuidedFormulationPillInternal from '../actions/onRemoveGuidedFormulationPillInternal';
import onSearchTextChanged from '../actions/onSearchTextChanged';
import startSearch from '../actions/startSearch';
import isSearchBoxEmpty from '../selectors/isSearchBoxEmpty';
import getSegmentSearchBoxText from '../utils/getSegmentSearchBoxText';
import { orchestrator } from 'satcheljs';

orchestrator(onGuidedFormulationSuggestionSelected, actionMessage => {
    const { scenarioId, segments, suggestionSelected } = actionMessage;

    // Clear search box when segments are added.
    clearSearchBox(scenarioId);

    // Update store with segment data.
    onGuidedFormulationSuggestionSelectedInternal(segments, scenarioId);

    // Update search text if suggestion was actually selected.
    if (suggestionSelected) {
        const lastSegment = segments.slice(-1)[0];
        onSearchTextChanged(
            getSegmentSearchBoxText(lastSegment),
            scenarioId,
            false /* showSuggestionsUi */
        );
    }
});

orchestrator(onRemoveGuidedFormulationPill, actionMessage => {
    const { scenarioId, segmentKey } = actionMessage;

    /**
     * Dispatch action to remove GF suggestion pill from the store. This is done
     * within this orchestrator insteading having an explicit mutator because
     * order matters and it must happen before checking if the search box is
     * empty.
     */
    onRemoveGuidedFormulationPillInternal(segmentKey, scenarioId);

    /**
     * After suggestion pill is removed, check if search box is empty. If search
     * box is not empty, dispatch a startSearch action to initiate search.
     *
     * If search box is empty, dispatch getSuggestions since search box content
     * has changed.
     */
    if (!isSearchBoxEmpty(scenarioId)) {
        startSearch('NonUserAction', scenarioId);
    } else {
        getSuggestions(scenarioId);
    }
});
